<template>
  <div class="container justify-content-center mt-5 company-payment-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 mt-3">
        <h3>{{ $t(LangConstants.your_order_heading) }}</h3>
        <div class="row">
          <payment-product-item :title="product.name" :imgUrl="product.images[0]" :subPeriod="this.paymentRecurringPeriod" :total="this.totalAmount" :description="product.description"> </payment-product-item>
        </div>

        <div class="row">
          <div class="col-md-12" v-show="currentStep == 1">
            <b-tabs
              v-model="tabIndex"
              content-class="col-md-12"
              class="custom-tab-control row d-flex justify-content-center align-items-center"
              align="center"
            >
              <div id="company-payment-create-account" class="row form-base mt-3">
                <b-tab active class="col-md-12">
                  <template #title>
                    <span>{{ $t(LangConstants.create_account_title) }}</span>
                  </template>

                  <h3 class="mb-3">{{ $t(LangConstants.create_account_title) }}</h3>

                  <div class="col-12 form1">
                    <b-form ref="frmOrderCompanyCreate" @submit.stop.prevent="proceedBtnHandler">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="first-name" name="first-name" :label="$t(LangConstants.first_name_input_label)" placeholder="Andrew" inlinerows="false" classes="bg-gray" ref="firstName" v-model="stateStep1.firstName" :error="stepOnev$.firstName.$error == true ? stepOnev$.firstName.$errors[0].$message : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="last-name" name="last-name" :label="$t(LangConstants.last_name_input_label)" placeholder="Hargempton" inlinerows="false" classes="bg-gray" ref="lastName" v-model="stateStep1.lastName" :error="stepOnev$.lastName.$error == true ? stepOnev$.lastName.$errors[0].$message : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="email" name="email" :label="$t(LangConstants.your_email_input_label)" placeholder="someemail@example.com" inlinerows="false" classes="bg-gray" ref="registerEmail" type="email" v-model="stateStep1.registerEmail" :error="stepOnev$.registerEmail.$error == true ? stepOnev$.registerEmail.$errors[0].$message : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="password" name="password" :label="$t(LangConstants.choose_password_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="registerPassword" type="password" v-model="stateStep1.registerPassword" :error="stepOnev$.registerPassword.$error == true ? stepOnev$.registerPassword.$errors[0].$message : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="phone" name="phone" :label="$t(LangConstants.phone_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="phone" v-model="stateStep1.phone" :error="stepOnev$.phone.$error == true ? stepOnev$.phone.$errors[0].$message : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="companyNo" name="companyNo" :label="$t(LangConstants.company_number_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="companyNo" v-model="stateStep1.companyNo" :error="stepOnev$.companyNo.$error == true ? stepOnev$.companyNo.$errors[0].$message : ''"></my-input>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-4">
                            <my-checkbox id="marketingAackknowledgement" name="marketingAackknowledgement" inlinerows="false" :defaultText="$t(LangConstants.marketing_consent_text)" :secondaryText="marketingConsentHelperText" checkedValue="1" uncheckedValue="0" v-model="stateStep1.sendmarketingemails"> </my-checkbox>
                          </div>
                        </div>
                      </div>

                      <div class="row"> 
                        <div class="col-md-12">
                          <div class="mb-4">
                            <my-button fa="bars" :label="$t(LangConstants.continue_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                          </div>
                        </div>
                      </div>
                    </b-form>
                  </div>
                </b-tab>
              </div>
            </b-tabs>
          </div>

          <div class="col-md-12" v-show="currentStep == 2">
            <div id="company-payment-select-url" class="form-base mt-5 row">
              <div class="col-12 form1">
                <h3 class="mb-3">{{ $t(LangConstants.sudomain_address_select_heading) }}</h3>
                <b-form class="" ref="frmOrderCompanySubdomainAddres" @submit.stop.prevent="proceedBtnHandler">
                  <div class="col-md-12">
                    <div class="row d-flex justify-content-center">
                      <div class="col-md-6">
                        <div class="mb-4">
                          <text-input-group id="subdomain" name="subdomain" :label="$t(LangConstants.subdomain_text_input_group_label)" :placeholder="$t(LangConstants.subdomain_text_input_group_placeholder)" inlinerows="false" classes="bg-brand-border-thick" btn_fa="" btn_label=".sparkfore.com" btn_variant="solid-primary" btn_classes="" btn_width="100%" :btn_inputGroup="true" ref="subdomain" v-model="stateStep2.subdomain" @input="validateSubdomain" :error="stepTwov$.subdomain.$error == true && stepTwov$.subdomain.$errors[0].$validator != 'domainMustBeAvailable' ? stepTwov$.subdomain.$errors[0].$message : ''"></text-input-group>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-if="stepTwov$.subdomain.$error == true && stepTwov$.subdomain.$errors[0].$validator == 'domainMustBeAvailable'">
                      <div class="col-md-12">
                        <alert-simple fa="exclamation-circle" :title="$t(LangConstants.domain_not_available_text)" :text="domainSuggestions" variant="warning"> </alert-simple>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="mb-4">
                          <my-button fa="bars" :label="$t(LangConstants.continue_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-show="currentStep == 3">
            <div id="company-payment-select-payment-method" class="d-flex justify-content-center form-base mt-5 row">
              <b-form class="col-md-12" ref="frmOrderCompanypaymentMethod" @submit.stop.prevent="proceedBtnHandler">
                <h3 class="mb-3">{{ $t(LangConstants.select_payment_method_heading) }}</h3>
                <div class="row">
                  <div class="col-12 form1">
                    <div class="row d-flex justify-content-center">
                      <div class="col-md-6">
                        <div class="mb-4">
                          <card-link fa="credit-card-alt" @onClick="payByCard" :title="$t(LangConstants.card_payment_title)" :text="$t(LangConstants.card_payment_helper_text)" bgvariant="red" textvariant="dark"></card-link>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="mb-4">
                          <card-link fa="file" @onClick="payByInvoice" :title="$t(LangConstants.invoice_payment_title)" :text="$t(LangConstants.invoice_payment_helper_text)" bgvariant="blue" textvariant="dark"></card-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <stripe-checkout ref="checkoutRef" mode="subscription" :pk="publishableKey" :line-items="lineItems" :success-url="successURL" :cancel-url="cancelURL" :session-id="sessionId" @loading="(v) => (loading = v)" />
  </div>
</template>

<script>
/**
 * Customer Subscription Purchase Page
 */
import useValidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";
import { reactive } from "@vue/composition-api";
import common from "../../../functions/index";
import Constants from "../../../constants/index";

import PaymentProductItem from "../../../components/atoms/PaymentProductItem.vue";
import "../../../assets/scss/companypayment.scss";
import "../../../assets/scss/stepper.scss";

import MyButton from "../../../components/atoms/Button.vue";
import MyInput from "../../../components/atoms/Input.vue";
import AlertSimple from "../../../components/atoms/Alert.vue";
import MyCheckbox from "../../../components/atoms/Checkbox.vue";

import TextInputGroup from "../../../components/organisms/TextInputGroup.vue";

import CardLink from "../../../components/atoms/CardLink.vue";

import { StripeCheckout } from "@vue-stripe/vue-stripe";
const nameGenerator = require("@rstacruz/startup-name-generator");

import { store } from "../../../store/store";

import i18n from "../../../i18n";

export default {
  name: "make-payment",
  async beforeCreate() {},
  async created() {
    // alert('created');

    const productSlug = this.$route.params.slug;
    const priceSlug = this.$route.params.priceslug;

    this.priceSlug = priceSlug;
    this.productSlug = productSlug;

    this.lineItems[0].price = priceSlug;

    // const paymentMethod = "card";

    this.$store.dispatch("getStripeProductById", productSlug).then((result) => {
      this.product = result;
    });

    this.$store.dispatch("getStripeProductPricesById", priceSlug).then((result) => {
      this.productPricing = result;
    });
  },
  setup() {
    const lists = reactive({ naughtyList: [], domains: [] });

    store.dispatch("getNaughtyList").then((result) => {
      lists.naughtyList = result;
    });

    store.dispatch("getDomains").then((result) => {
      if (result.length > 0) {
        lists.domains = result.map((elem) => {
          let url = new URL(elem.lms_url);

          const hostname = url.hostname;

          if (hostname.endsWith("sparkfore.com")) {
            return url.hostname
              .split(".")
              .slice(0, -2)
              .join(".");
          }
        });
      }
    });

    const domainMustBeValid = (value) => {
      const re = new RegExp(/^[a-z0-9]+$/i);
      return re.test(value);
    };

    const domainMustNotBeNaughty = (value) => {
      const isNaughty = lists.naughtyList.some((v) => value.includes(v));

      if (!isNaughty) {
        return true;
      }
      return false;
    };

    const domainMustBeAvailable = (value) => {
      const isAvailable = lists.domains.some((v) => value == v);
      // console.log(lists.domains);
      // console.log(isAvailable);
      if (!isAvailable) {
        return true;
      }
      return false;
    };

    const passwordMustBeValid = (value) => {
      const re = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[-=_)(*^%$@!~`])[A-Za-z\d-=_)(*^%$@!~`]{6,}$/);
      return re.test(value);
    };

    const stateSignIn = reactive({
      loginEmail: "",
      password: "",
    });

    const stateStep1 = reactive({
      firstName: "",
      lastName: "",
      registerEmail: "",
      registerPassword: "",
      phone: "",
      companyNo: "",
      sendmarketingemails: false,
    });

    const stateStep2 = reactive({
      subdomain: "",
    });

    const state = reactive({
      field1: "1",
    });

    const rulesSignIn = {
      loginEmail: { required, email },
      password: { required },
    };

    const rulesStep1 = {
      firstName: { required },
      lastName: { required },
      registerEmail: { required, email },
      registerPassword: {
        required,
        passwordMustBeValid: helpers.withMessage(i18n.t(Constants.general_password_validation_message), passwordMustBeValid),
      },
      phone: { required },
      companyNo: { required },
    };

    const rulesStep2 = {
      subdomain: {
        required,
        domainMustBeValid: helpers.withMessage(i18n.t(Constants.subdomain_can_contain_alphanumeric_chars_message), domainMustBeValid),
        domainMustNotBeNaughty: helpers.withMessage(i18n.t(Constants.censorship_triggered_message), domainMustNotBeNaughty),
        domainMustBeAvailable: helpers.withMessage(i18n.t(Constants.subdomain_not_available_message), domainMustBeAvailable),
      },
    };

    const rules = {
      field1: { required },
    };

    const signInv$ = useValidate(rulesSignIn, stateSignIn);
    const stepOnev$ = useValidate(rulesStep1, stateStep1);
    const stepTwov$ = useValidate(rulesStep2, stateStep2);
    const v$ = useValidate(rules, state);

    return {
      stateStep1,
      stateStep2,
      stateSignIn,
      stepOnev$,
      stepTwov$,
      signInv$,
      v$,
      loading: false,

      successURL: store.getters.spInstanceVueURL + "company-account/makepayment/purchase/subscription/success",
      cancelURL: store.getters.spInstanceVueURL + "company-account/makepayment/purchase/subscription/failed",
    };
  },
  data() {
    this.publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    return {
      priceSlug: null,
      productSlug: null,
      lineItems: [
        {
          price: null, // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      currentStep: 1,
      currentTab: "signup",
      userData: {},
      product: [],
      productPricing: null,
      // cardPayment: null,
      tabIndex: 0,
      domainSuggestions: "",
      sessionId: "",
    };
  },

  methods: {
    async proceedBtnHandler() {
      var validated = false;

      switch (this.currentStep) {
        case 1:
          if (this.tabIndex == 0) {
            this.stepOnev$.$validate();
            console.log(this.stepOnev$);
            validated = this.stepOnev$.$error == true ? false : true;
          } else {
            this.signInv$.$validate();
            validated = this.signInv$.$error == true ? false : true;
          }

          break;

        case 2:
          this.stepTwov$.$validate();
          // console.log(this.stepTwov$);
          validated = this.stepTwov$.$error == true ? false : true;

          break;
      }
      // console.log(validated);
      if (validated == true) {
        this.currentStep += 1;
        this.$root.$emit("company-payment-wizard-step", this.currentStep);
      }
    },

    validateSubdomain() {
      this.stepTwov$.$validate();
      if (this.stepTwov$.$error == true && this.stepTwov$.$errors[0].$validator == "domainMustBeAvailable") {
        this.domainSuggestions = Constants.choose_different_subdomain_message + " " + this.getDomainSuggestions(this.stateStep2.subdomain).join(", ");
      }
    },

    async processLogin() {},
    async ProcessRegister() {},
    async payByCard() {
      this.$store
        .dispatch("createStripeCheckoutSession", {
          lineItems: this.lineItems,
          successURL: this.successURL,
          cancelURL: this.cancelURL,
          subdomain: this.stateStep2.subdomain,
          product: this.product.name,

          form_firstName: this.stateStep1.firstName,
          form_lastName: this.stateStep1.lastName,
          form_registerEmail: this.stateStep1.registerEmail,
          registerPassword: this.stateStep1.registerPassword,
          form_phone: this.stateStep1.phone,
          form_companyNo: this.stateStep1.companyNo,
          form_sendmarketingemails: this.stateStep1.sendmarketingemails,
        })
        .then((session) => {
          if (session.success == true) {
            // this.successURL = `${this.successURL}/${session.data.id}`
            // this.cancelURL = `${this.cancelURL}/${session.data.id}`
            this.sessionId = session.data.id;
            this.cacheFormData(session.data.id);
            this.$refs.checkoutRef.redirectToCheckout();
          } else {
            this.$fire({
              title: this.$t(Constants.common_error_title),
              text: this.$t(Constants.please_try_again_text),
              type: "error",
              html: "",
            });
          }
        });
    },

    async payByInvoice() {
      const customerParams = {
        email: this.currentTab == "signup" ? this.stateStep1.registerEmail : this.stateSignIn.loginEmail,
        // payment_method: "pm_card_visa",
        // "invoice_settings[default_payment_method]": "pm_card_visa",
      };

      await this.$store
        .dispatch("createStripeCustomer", customerParams)
        .then((result) => {
          result = JSON.parse(JSON.stringify(result));

          const subscriptionParams = {
            customer: result["id"],
            "items[0][price]": this.priceSlug,
            // "payment_settings[payment_method_types][]": "card",
            collection_method: "send_invoice",
            days_until_due: 30,
            "metadata[subdomain]": this.stateStep2.subdomain,
            "metadata[product]": this.product.name,

            "metadata[form_firstName]": this.stateStep1.firstName,
            "metadata[form_lastName]": this.stateStep1.lastName,
            "metadata[form_registerEmail]": this.stateStep1.registerEmail,
            // "metadata[product]": this.stateStep1.registerPassword,
            "metadata[form_phone]": this.stateStep1.phone,
            "metadata[form_companyNo]": this.stateStep1.companyNo,
            "metadata[form_sendmarketingemails]": this.stateStep1.sendmarketingemails,
          };

          this.$store
            .dispatch("createStripeSubscription", subscriptionParams)
            .then((subscription) => {
              result = JSON.parse(JSON.stringify(subscription));

              this.$store.dispatch("sendStripeInvoiceForPayment", result["latest_invoice"]).then((result) => {
                // console.log("Stripe Invoice Send");
                // console.log(result);

                result = JSON.parse(JSON.stringify(subscription));
                this.sessionId = result.id;
                this.cacheFormData(result["id"]);

                this.$fire({
                  title: this.$t(Constants.subscription_status_error_heading),
                  text: this.$t(Constants.subscription_creation_success_message),
                  type: "success",
                  html: "",
                  timer: 3000,
                }).then(() => {
                  this.$router.push({
                    name: "CompanyMakePaymentSuccess",
                    params: { id: result["id"], type: "subscription" },
                  });
                });
              });
            })
            .catch((error) => {
              this.$fire({
                title: this.$t(Constants.subscription_status_error_heading),
                text: this.$t(Constants.subscription_creation_error_message),
                type: "error",
                html: "<div>" + this.$t(error) + "</div>",
                timer: 3000,
              }).then(() => {
                this.$router.push({ name: "CompanyMakePaymentFail" });
              });
            });
        })
        .catch((error) => {
          this.$fire({
            title: this.$t(Constants.subscription_status_error_heading),
            text: this.$t(Constants.subscription_creation_error_message),
            type: "error",
            html: "<div>" + this.$t(error) + "</div>",
            timer: 3000,
          }).then(() => {
            this.$router.push({ name: "CompanyMakePaymentFail" });
          });
        });
    },

    getDomainSuggestions(keyword) {
      let domainSuggestions = nameGenerator(keyword);
      domainSuggestions = domainSuggestions.slice(0, 20);
      // domainSuggestions.push('bannedhello')
      // domainSuggestions.push('hellobanned')
      // domainSuggestions.push('hellobannedhello')
      // domainSuggestions.push('lms')
      // domainSuggestions.push('hello')

      domainSuggestions = domainSuggestions.filter((suggestion) => {
        for (const word of this.naughtyList) {
          if (!suggestion.includes(word)) {
            return suggestion;
          }
        }
      });

      domainSuggestions = domainSuggestions.filter((suggestion) => !this.domains.includes(suggestion));
      domainSuggestions = domainSuggestions.map((suggestion) => suggestion.toLowerCase()).slice(0, 5);

      return domainSuggestions;
    },

    cacheFormData(key) {
      const formData = {
        user: {
          first_name: this.stateStep1.firstName,
          last_name: this.stateStep1.lastName,
          email: this.stateStep1.registerEmail,
          password: this.stateStep1.registerPassword,
          phone: this.stateStep1.phone,
          receive_marketing_emails: this.stateStep1.sendmarketingemails,
        },
        customer: {
          lms_url: "www." + this.stateStep2.subdomain + ".sparkfore.com",
          organization_number: this.stateStep1.companyNo,
        },
        product: {
          price_id: this.priceSlug,
        },
      };

      common.setinLocalStorage(key, formData);
    },
  },
  computed: {
    customers() {
      return this.$store.getters.allCustomers;
    },
    naughtyList() {
      return this.$store.getters.getNaughtyList;
    },
    domains() {
      return this.$store.getters.getDomains;
    },
    totalAmount() {
      if (this.productPricing != null) {
        return common.thousandSeparator(this.productPricing.unit_amount) + " " + common.toUpperCase(this.productPricing.currency);
      }
      return "00.00";
    },
    paymentRecurringPeriod() {
      if (this.productPricing != null) {
        return common.getIntervalByNoun(this.productPricing.recurring.interval);
      }
      return "";
    },
    LangConstants() {
      return Constants;
    },

    marketingConsentHelperText() {
      return "(" + this.$t(Constants.marketing_consent_helper_text) + ")";
    },
  },

  components: {
    PaymentProductItem,
    MyButton,
    MyInput,
    TextInputGroup,
    AlertSimple,
    MyCheckbox,
    CardLink,
    StripeCheckout,
  },
};
</script>
